import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { ToastrService } from "ngx-toastr";

import { BaseService } from "./base.service";
import { IBusinessFunction } from "../interfaces/ibusinessfunction";
import { ApplicationSettingsService } from "./applicationsettings.service";
import { AuthService } from "./auth.service";
/**
 * @WhatItDoes A service to cater the requirement on admin home page.
 *
 * @HowToUseIt Inject the service
 */
@Injectable()
export class BusinessFunctionService extends BaseService {
  /**
   * Constructor for service
   * @param http angular http module
   * @param applicationSettings application settings for the URL
   */
    constructor(http: HttpClient,
        private applicationSettings: ApplicationSettingsService,
        authService: AuthService,
        toastsManager: ToastrService) {
        super(http, authService, toastsManager);
    }

    /**
     * Returns an observable of last updated date
     */
    getLastUdpatedDate(): Observable<Date> {
        return super.get(`${this.applicationSettings.apiUrl}contentlatestupdate`);
    }

    /**
     * Returns all business functions
     */
    getAll(): Observable<IBusinessFunction[]> {
        return super.get(`${this.applicationSettings.apiUrl}businessfunction`);
  }

    /**
  * Returns all business functions
  */
    getUserBusinessFunctions(): Observable<IBusinessFunction[]> {
      return super.get(`${this.applicationSettings.apiUrl}businessfunction/user`);
    }

    getBusinessFunction(id: number): Observable<IBusinessFunction> {
        return super.get(`${this.applicationSettings.apiUrl}businessfunction/${id}`);
    }
    
    getImage(id: number): Observable<string> {
        return super.getText(`${this.applicationSettings.apiUrl}businessfunction/getImage/${id}`);
    }    
}